import { __assign, __extends } from "tslib";
import React from 'react';
/**
 * Renders an anchor tag with an href of '/' unless otherwise specified.
 * The onClick event will call preventDefault() so that the anchor acts like a button instead of a link to a url.
 */
var Link = /** @class */ (function (_super) {
    __extends(Link, _super);
    function Link(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }
    Link.prototype.onClick = function (e) {
        e.preventDefault();
        if (this.props.onClick) {
            this.props.onClick(e);
        }
    };
    Link.prototype.render = function () {
        var _a;
        var props = this.props;
        var href = (_a = props.href) !== null && _a !== void 0 ? _a : "/";
        return React.createElement("a", __assign({}, props, { href: href, onClick: this.onClick }), this.props.children);
    };
    return Link;
}(React.Component));
export default Link;
